/* eslint-disable */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import useCustomizableContext from "../../../useCustomizableContext";
import useModel3D from "../../ModelViewer/ModelScene/three/hooks/useModel3D";
import { doesRegionHaveCustomizations } from "~/CustomizableToolPage/fabric/utils";

interface Props {
  loadingCart: boolean;
  navigationSidebarVisible: boolean;
  toggleNavigationSidebar: () => void;
}

const NavigationMenu = ({
  loadingCart,
  navigationSidebarVisible,
  toggleNavigationSidebar,
}: Props) => {
  const {
    // @ts-ignore
    selectedRegion,
    // @ts-ignore
    currentNavigationKey: { currentNavigationKey },
    // thunks
    // @ts-ignore
    changeRegion,
    // @ts-ignore
    changeNavigationKey,
    // selectors
    // @ts-ignore
    getNavigationKeyData,
    // @ts-ignore
    getIsPricingAvailable,
    regionData,
    // Fabric
    fabric: { regions },
  } = useCustomizableContext();

  const { transitionModelView } = useModel3D();

  const handleNavigationChange = (
    navigationKey: number,
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    const navigationKeyData = getNavigationKeyData();

    if (navigationKey !== currentNavigationKey && !loadingCart) {
      changeNavigationKey({
        currentNavigationKey: navigationKey,
        currentNavigationKeyType: navigationKeyData[navigationKey]?.optionName,
      });

      const navigationKeyDataForCurrentNavigationKey =
        navigationKeyData[navigationKey];

      // if we are entering the pricing section, we have no regions to check for
      if (navigationKeyDataForCurrentNavigationKey?.optionName !== "pricing") {
        // we want to take the user to the next available region in the selected option
        const regionsToCheck =
          navigationKeyDataForCurrentNavigationKey?.regions;

        let changeToRegionId = 0;

        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const region in regionsToCheck) {
          const valid = regionsToCheck[region]?.active;
          // const valid = !regionType || regionType === targetRegionType;
          // if the current region is available in the selected option lets stay in this region
          if (
            selectedRegion === Number(region) &&
            valid
            // regionsToCheck[region]?.active
          ) {
            changeToRegionId = Number(region);
            break;
          } else if (valid && changeToRegionId === 0) {
            // otherwise we only want to switch to the first available region
            changeToRegionId = Number(region);
          }
        }

        // switch to an available region and only then change the panel type
        if (changeToRegionId && selectedRegion !== changeToRegionId) {
          // only attempt to change region and camera/position if we are going to a new region
          changeRegion(changeToRegionId);
        }
      }
    }
  };

  const handleRegionChange = (
    regionId: number,
    active: boolean,
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    event.preventDefault();
    if (active) {
      changeRegion(regionId);
      transitionModelView(regionData![selectedRegion]!);
    }
  };

  return (
    <div
      id="navigation-menu"
      className={`customize__box-sidebar${
        navigationSidebarVisible ? " in" : ""
      }`}
    >
      <span
        className="customize__menu-icon customize__menu-icon--close icon-cancel"
        onClick={toggleNavigationSidebar}
      >
        Close
      </span>
      <ul className="customize__option-list">
        {getNavigationKeyData()
          // @ts-ignore
          .map((item, index) => {
            if (!(item.optionName === "pricing" && !getIsPricingAvailable())) {
              return (
                <li key={item.id}>
                  <a
                    href="#"
                    className={`customize__option ${
                      currentNavigationKey === index ? "active " : ""
                    } ${loadingCart ? "disabled" : ""}`}
                    onClick={(e) => handleNavigationChange(index, e)}
                  >
                    <span className={`customize__option-icon ${item.icon}`} />{" "}
                    {item.type}{" "}
                  </a>
                  {item.optionName !== "pricing" && (
                    <ul className="customize__option-list customize__option-list--sub">
                      {item.regions &&
                        Object.values(item.regions).map((region) => {
                          // @ts-ignore
                          const disable = !region.active;

                          return (
                            // @ts-ignore
                            <li key={region.id}>
                              <a
                                href="#"
                                className={`customize__option--sub${
                                  disable ? " disabled" : ""
                                }${
                                  // @ts-ignore
                                  region.id === selectedRegion ? " current" : ""
                                }
                          ${
                            // @ts-ignore
                            !disable && doesRegionHaveCustomizations(regions[region.id!])
                              ? " complete"
                              : ""
                          }`}
                                onClick={(e) =>
                                  !disable &&
                                  handleRegionChange(
                                    // @ts-ignore
                                    region.id!,
                                    // @ts-ignore
                                    region.active!,
                                    e
                                  )
                                }
                              >
                                {
                                  // @ts-ignore
                                  region.regionName
                                }
                                {disable && (
                                  <span
                                    className="icon icon-question"
                                    title="This region cannot be customized with selected regions."
                                  />
                                )}
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                  )}
                </li>
              );
            }

            return null;
          })}
      </ul>
    </div>
  );
};

export default NavigationMenu;
